import { Button, Form } from 'antd';
import { postApi } from 'apis';
import InputWithLabelAndSvg from 'components/Global/InputWithLabel';
import { FORMDATA } from 'constants/Data';
import React, { FC, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';

const AddCategoryBody: FC<SideDrawerBodyProps> = (props) => {
	// Inits
	const { subCategoryFields } = FORMDATA;
	const { closeDrawerByAnimation, editSelectedSubCategory, fetchCategory, selectedCategory } = props;
	const [form] = Form.useForm();

	// State Management
	const [loading, setLoading] = useState<boolean>();
	const editData = {
		...editSelectedSubCategory,
	};
	
	const onFinish = async (values: any) => {
		setLoading(true);

		const endpoint = editSelectedSubCategory
			? `/sub-category/update/${editData?.id}`
			: `/sub-category/create`;

		try {
			const res = await postApi(endpoint, { ...values, categoryId: selectedCategory });

			if (res?.data?.responseStatus === 200) {
				toastText(res?.data?.message, 'success');
			} else {
				throw new Error(res?.data?.message || 'Unexpected response');
			}
		} catch (error: any) {
			toastText(
				error?.response?.data?.message ?? 'Something went wrong',
				'error'
			);
		} finally {
			setLoading(false);
			fetchCategory();
			closeDrawerByAnimation();
		}
	};


	// JSX
	return (
		<div className={styles['side-drawer-body']}>
			<Form
				form={form}
				name="basic"
				initialValues={editData}
				onFinish={onFinish}
				autoComplete="off"
				layout="vertical"
				labelAlign="left"
				className={styles['side-drawer-form']}
			>
				<div className={styles['side-drawer-form__inputs']}>
					{subCategoryFields.map((singleField: any, index: number) => {
						return (
							<React.Fragment key={index}>
								<InputWithLabelAndSvg
									singleUserInput={singleField}
								/>
							</React.Fragment>
						);
					})}
				</div>

				<div className={styles['side-drawer-form__buttons']}>
					<Button
						htmlType="submit"
						className={styles['side-drawer-form__buttons--edit']}
						loading={loading}
					>
						{editSelectedSubCategory ? 'Edit' : 'Save'}
					</Button>

					<Button
						htmlType="reset"
						className={styles['side-drawer-form__buttons--cancel']}
						onClick={closeDrawerByAnimation}
					>
						Cancel
					</Button>
				</div>


			</Form>
		</div>
	);
};

export default AddCategoryBody;
